class Timeline extends HTMLElement {
  constructor() {
    super();

    this.element = this.querySelector('timeline');
    // this.delegateElement = new domDelegate.Delegate(this);
    this.items = this.querySelectorAll('.timeline__item');
    // console.log('this.items', this.items);
    this.navItems = this.querySelectorAll('.timeline__navitem');

    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('.timeline__navitem').forEach(navItem => navItem.addEventListener('click', this.clickOnNavItem.bind(this)));
    // this.querySelectorAll('.timeline__navitem').forEach(navItem => Shopify.addListener(navItem, 'click', this.clickOnNavItem.bind(this)));
  }

  clickOnNavItem(event) {
    var target = event.target.closest('.timeline__navitem');
    var newItem = this.items[parseInt(target.getAttribute('data-index'))];

    if (newItem.classList.contains('is-selected')) {
      return;
    }

    var isContentLarger = false,
        navWrapper = target.parentNode,
        scrollableOffset = 0;

    var scrollableWidth = navWrapper.scrollWidth,
        visibleWidth = navWrapper.offsetWidth;
    isContentLarger = visibleWidth < scrollableWidth;

    if (isContentLarger) {
      var beginBound = target.offsetLeft,
          endBound = beginBound + target.offsetWidth,
          closerToLeft = beginBound <= visibleWidth - endBound;
      var itemToUse = null;

      if (closerToLeft) {
        // If closer to left, we try to make the previous item visible (if possible)
        itemToUse = target.previousElementSibling || target;
      } else {
        // If closer to right, we try to make the next item visible (if possible)
        itemToUse = target.nextElementSibling || target;
      }

      var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
          itemEndBound = itemBeginBound + itemToUse.offsetWidth;

      if (itemEndBound > visibleWidth) {
        // Element is not visible from the right, so we must move by a given amount so that endBound is within viewable screen
        scrollableOffset = itemEndBound - visibleWidth;
      } else if (itemBeginBound < 0) {
        // Element is not visible from the left, so we simply use the opposite of the negative offset
        scrollableOffset = itemBeginBound;
      }
    }

    setTimeout(() => {
      if (isContentLarger) {
        navWrapper.scrollBy({
          behavior: 'smooth',
          left: scrollableOffset
        });
      } // First we set the class on the selected item and remove it on siblings

      this.querySelectorAll('.is-selected').forEach(function (item) {
        item.classList.remove('is-selected');
      }); // Then we slide to the appropriate element

      target.classList.add('is-selected');
      newItem.classList.add('is-selected');
    });

  }

}

customElements.define('time-line', Timeline);
//
// var TimelineSection = /*#__PURE__*/function () {
//   function TimelineSection(container) {
//     _classCallCheck(this, TimelineSection);
//
//     this = container;
//     this.delegateElement = new domDelegate.Delegate(this);
//     this.items = Dom.nodeListToArray(this.querySelectorAll('.timeline__item'));
//     this.navItems = Dom.nodeListToArray(this.querySelectorAll('.timeline__navitem'));
//
//     this.bindEvents();
//   }
//
//   _createClass(TimelineSection, [{
//     key: "onUnload",
//     value: function onUnload() {
//       this.delegateElement.off('click');
//     }
//   }, {
//     key: "onBlockSelect",
//     value: function onBlockSelect(event) {
//       this.navItems[parseInt(event.target.getAttribute('data-index'))].click(); // Simulate a click on the given nav item
//     }
//   }, {
//     key: "bindEvents",
//     value: function bindEvents() {
//       this.delegateElement.addEventListener('click', '.timeline__navitem', this._clickOnNavItem.bind(this));
//     }
//   }]);
//
//   return TimelineSection;
// }();
